





























import { Vue, Component, Prop } from 'vue-property-decorator'
import { authStore, notificacionesStore } from '@/store'
import Footer from '@/components/commons/Footer.vue'
import ToolbarUser from '@/components/commons/ToolbarUser.vue'

@Component({ components: { Footer, ToolbarUser } })
export default class GenericPage extends Vue {
  @Prop({ type: Boolean })
  showOverlay: boolean

  @Prop({ type: Boolean, default: false })
  hideToolbar: boolean

  @Prop({ type: String })
  mobileTitle: string

  /** Store de Auth */
  private get authStore() {
    return authStore
  }
  private get items() {
    return notificacionesStore.notificaciones
  }
  remove(index) {
    notificacionesStore.delete(index)
  }
  private get user() {
    return authStore.user
  }
  private onLogout() {
    if (this.authStore) this.authStore.logout()
  }
}
